(function () {
  var STYLE_ID = 'recovery-claim-btn-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '@keyframes recovery-claim-spin{to{transform:rotate(360deg)}}' +
      '.recovery_kit_claim_button.is-recovery-claim-loading{' +
      'pointer-events:none;cursor:wait;}' +
      '.recovery_kit_claim_button .recovery-claim-btn__spinner{' +
      'display:inline-block;width:1.15em;height:1.15em;margin-inline-start:0.5em;' +
      'vertical-align:-0.15em;flex-shrink:0;border:2px solid currentColor;' +
      'border-right-color:transparent;border-radius:50%;' +
      'animation:recovery-claim-spin .55s linear infinite;opacity:.95}';
    document.head.appendChild(style);
  }

  function setClaimLoading(el, on) {
    if (on) {
      injectStyles();
      el.classList.add('is-recovery-claim-loading');
      el.setAttribute('aria-busy', 'true');
      if (!el.querySelector('.recovery-claim-btn__spinner')) {
        var spin = document.createElement('span');
        spin.className = 'recovery-claim-btn__spinner';
        spin.setAttribute('aria-hidden', 'true');
        el.appendChild(spin);
      }
    } else {
      el.classList.remove('is-recovery-claim-loading');
      el.removeAttribute('aria-busy');
      var existing = el.querySelector('.recovery-claim-btn__spinner');
      if (existing) {
        existing.remove();
      }
    }
  }

  function cartBasePath() {
    if (typeof window.theme !== 'undefined' && window.theme.routes && window.theme.routes.cart) {
      return String(window.theme.routes.cart).replace(/\/$/, '');
    }
    return '/cart';
  }

  function checkoutUrl() {
    if (typeof window.theme !== 'undefined' && window.theme.routes && window.theme.routes.checkout) {
      return String(window.theme.routes.checkout);
    }
    return '/checkout';
  }

  function parseVariantAttr(el, name) {
    var raw = el.getAttribute(name);
    var id = raw ? parseInt(raw, 10) : NaN;
    return Number.isFinite(id) ? id : null;
  }

  function buildClaimItems(mainVariantId, el) {
    var items = [{ id: mainVariantId, quantity: 1 }];
    var giftId = parseVariantAttr(el, 'data-free-gift-variant-id');
    if (giftId != null && giftId !== mainVariantId) {
      items.push({ id: giftId, quantity: 1 });
    }
    return items;
  }

  function addClaimItems(items) {
    return fetch(cartBasePath() + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: items,
      }),
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        if (text) {
          try {
            data = JSON.parse(text);
          } catch (ignore) {
            data = { message: text };
          }
        }
        if (!res.ok) {
          throw data;
        }
        return data;
      });
    });
  }

  function formatAddError(err) {
    if (!err || typeof err !== 'object') {
      return 'Could not add to cart. Please try again.';
    }
    if (typeof err.description === 'string') {
      return err.description;
    }
    if (err.description && typeof err.description === 'object') {
      var d = err.description;
      if (Array.isArray(d)) {
        return d.join(', ');
      }
      return Object.keys(d)
        .map(function (k) {
          var v = d[k];
          return k + ': ' + (Array.isArray(v) ? v.join(', ') : String(v));
        })
        .join('. ');
    }
    if (typeof err.message === 'string') {
      return err.message;
    }
    if (err.errors && typeof err.errors === 'object') {
      var parts = [];
      Object.keys(err.errors).forEach(function (k) {
        var v = err.errors[k];
        parts.push(k + ' ' + (Array.isArray(v) ? v.join(', ') : String(v)));
      });
      if (parts.length) {
        return parts.join('. ');
      }
    }
    return 'Could not add to cart. Please try again.';
  }

  document.addEventListener(
    'click',
    function (e) {
      var optionBtn = e.target.closest('[data-setup-claim-option]');
      if (optionBtn && !optionBtn.disabled) {
        var root = optionBtn.closest('[data-setup-claim-root]');
        if (root) {
          var choices = root.querySelector('[data-setup-claim-choices]');
          var claimBtn = root.querySelector('.recovery_kit_claim_button');
          var vid = optionBtn.getAttribute('data-setup-claim-option');
          if (choices && claimBtn && vid) {
            claimBtn.setAttribute('data-variant-id', vid);
            var all = choices.querySelectorAll('[data-setup-claim-option]');
            for (var i = 0; i < all.length; i++) {
              var b = all[i];
              var on = b === optionBtn;
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
              b.classList.toggle('hero-setup-option--selected', on);
            }
          }
        }
        return;
      }

      var el = e.target.closest('.recovery_kit_claim_button');
      if (!el) {
        return;
      }

      e.preventDefault();

      if (
        el.getAttribute('aria-disabled') === 'true' ||
        el.classList.contains('is-recovery-claim-loading')
      ) {
        return;
      }

      var raw =
        el.getAttribute('data-variant-id') || el.getAttribute('data-product-id');
      var variantId = raw ? parseInt(raw, 10) : NaN;
      if (!Number.isFinite(variantId)) {
        var ctx = el.getAttribute('data-claim-context') || 'recovery';
        var setupMsg =
          'Setup offer is not linked in the theme. In the theme editor, open Theme settings → Fridge / Setup landing page and select the main product (and free gift variant if needed).';
        var recoveryMsg =
          'Recovery kit is not linked in the theme. In the theme editor, open Theme settings → Recovery landing page and select the recovery kit product.';
        var compareMsg =
          'This compare card has no product selected. In the theme editor, open the Compare Kits section and choose a product on that kit card block.';
        var msg = recoveryMsg;
        if (ctx === 'setup') msg = setupMsg;
        else if (ctx === 'compare') msg = compareMsg;
        window.alert(msg);
        return;
      }

      el.setAttribute('aria-disabled', 'true');
      setClaimLoading(el, true);

      addClaimItems(buildClaimItems(variantId, el))
        .then(function () {
          window.location.assign(checkoutUrl());
        })
        .catch(function (err) {
          window.alert(formatAddError(err));
        })
        .finally(function () {
          setClaimLoading(el, false);
          el.removeAttribute('aria-disabled');
        });
    },
    false
  );
})();
